import React from 'react';
import { Container, Divider, Grid, Typography } from '@mui/material';
import { environment } from '../../../environments/environment';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../Menu/index.css';
import aboutus from '../../../assets/aboutus.png';
import footer from '../../../assets/background.png';
import foodImage from '../../../assets/pizza.png';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../components/common/SectionHeader';
import AboutFoodSection from '../../components/common/AboutFoodSection';

function Aboutus() {
  const [t, i18n] = useTranslation();

  return (
    <div>
      {environment.restaurantId === 'istanbulDk' && (
        <>
          <img
            alt="tesxt"
            src={aboutus} // use normal <img> attributes as props
            width="100%"
            style={{ height: '550px' }}
          />
          <Container maxWidth={'lg'} style={{ marginTop: '20px' }}>
            <div
              style={{
                position: 'relative',

                backgroundImage: `url(${footer})`,
              }}
            >
              <Container maxWidth={'xl'}>
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '40px',
                    justifyContent: 'space-between',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    style={{
                      alignItems: 'center',
                      marginTop: '10px',
                      marginBottom: '30px',
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        color: environment.mainColor,
                        fontWeight: 'bold',
                        fontFamily: `Hanalei Fill, cursive`,
                      }}
                      sx={{ fontSize: { xs: '40px', md: '60px', lg: '40px' } }}
                    >
                      {t('aboutUs.aboutTitle')}
                    </Typography>
                    <Grid
                      item
                      xs={2}
                      direction="row"
                      style={{
                        display: 'flex',
                        alignItems: 'center ',
                        marginBottom: '10px',
                      }}
                    >
                      <span
                        className="dot"
                        style={{ backgroundColor: environment.mainColor }}
                      ></span>

                      <Divider
                        style={{
                          marginBottom: '5px',
                          marginTop: '5px',
                          height: '2px',
                          backgroundColor: environment.mainColor,
                          width: '50%',
                          marginLeft: '8px',
                        }}
                      />
                    </Grid>

                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {t('aboutUs.aboutDescOne')}

                      <br />
                      {t('aboutUs.aboutDescTwo')}

                      <br />
                      {t('aboutUs.aboutDescThree')}

                      <br />
                      {t('aboutUs.aboutDescFour')}

                      <br />
                      {t('aboutUs.aboutDescFive')}
                    </Typography>
                  </Grid>
                </Grid>
              </Container>
            </div>
          </Container>
        </>
      )}
      {environment.restaurantId === 'ttJordanDev' && (
        <>
          <img
            alt="tesxt"
            src={aboutus} // use normal <img> attributes as props
            width="100%"
            style={{ height: '550px' }}
          />
          <Container maxWidth={'lg'} style={{ marginTop: '20px' }}>
            <div
              style={{
                position: 'relative',

                backgroundImage: `url(${footer})`,
              }}
            >
              <Container maxWidth={'xl'}>
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '40px',
                    justifyContent: 'space-between',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    style={{
                      alignItems: 'center',
                      marginTop: '10px',
                      marginBottom: '30px',
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        color: environment.mainColor,
                        fontWeight: 'bold',
                        fontFamily: `Hanalei Fill, cursive`,
                      }}
                      sx={{ fontSize: { xs: '40px', md: '60px', lg: '40px' } }}
                    >
                      {t('aboutUs.aboutTitle')}
                    </Typography>
                    <Grid
                      item
                      xs={2}
                      direction="row"
                      style={{
                        display: 'flex',
                        alignItems: 'center ',
                        marginBottom: '10px',
                      }}
                    >
                      <span
                        className="dot"
                        style={{ backgroundColor: environment.mainColor }}
                      ></span>

                      <Divider
                        style={{
                          marginBottom: '5px',
                          marginTop: '5px',
                          height: '2px',
                          backgroundColor: environment.mainColor,
                          width: '50%',
                          marginLeft: '8px',
                        }}
                      />
                    </Grid>

                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {t('aboutUs.aboutDescOne')}

                      <br />
                      {t('aboutUs.aboutDescTwo')}

                      <br />
                      {t('aboutUs.aboutDescThree')}

                      <br />
                      {t('aboutUs.aboutDescFour')}

                      <br />
                      {t('aboutUs.aboutDescFive')}
                    </Typography>
                  </Grid>
                </Grid>
              </Container>
            </div>
          </Container>
        </>
      )}
      {environment.restaurantId === 'ttJordan' && (
        <>
          <img
            alt="tesxt"
            src={aboutus} // use normal <img> attributes as props
            width="100%"
            style={{ height: '550px' }}
          />
          <Container maxWidth={'lg'} style={{ marginTop: '20px' }}>
            <div
              style={{
                position: 'relative',

                backgroundImage: `url(${footer})`,
              }}
            >
              <Container maxWidth={'xl'}>
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '40px',
                    justifyContent: 'space-between',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    style={{
                      alignItems: 'center',
                      marginTop: '10px',
                      marginBottom: '30px',
                    }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        color: environment.mainColor,
                        fontWeight: 'bold',
                        fontFamily: `Hanalei Fill, cursive`,
                      }}
                      sx={{ fontSize: { xs: '40px', md: '60px', lg: '40px' } }}
                    >
                      {t('aboutUs.aboutTitle')}
                    </Typography>
                    <Grid
                      item
                      xs={2}
                      direction="row"
                      style={{
                        display: 'flex',
                        alignItems: 'center ',
                        marginBottom: '10px',
                      }}
                    >
                      <span
                        className="dot"
                        style={{ backgroundColor: environment.mainColor }}
                      ></span>

                      <Divider
                        style={{
                          marginBottom: '5px',
                          marginTop: '5px',
                          height: '2px',
                          backgroundColor: environment.mainColor,
                          width: '50%',
                          marginLeft: '8px',
                        }}
                      />
                    </Grid>

                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {t('aboutUs.aboutDescOne')}

                      <br />
                      {t('aboutUs.aboutDescTwo')}

                      <br />
                      {t('aboutUs.aboutDescThree')}

                      <br />
                      {t('aboutUs.aboutDescFour')}

                      <br />
                      {t('aboutUs.aboutDescFive')}
                    </Typography>
                  </Grid>
                </Grid>
              </Container>
            </div>
          </Container>
        </>
      )}
      {(environment.restaurantId === 'fattyPattyDev' ||
        environment.restaurantId === 'fattyPatty') && (
        <>
          <SectionHeader
            title="About Us"
            breadcrumbs={[
              { label: 'Home', path: '/' },
              { label: 'About Us', current: true },
            ]}
            fontFamily="Jost"
            showBreadcrumbs={true}
            titleVariant="h2"
            customStyles={{
              title: { fontSize: '40px', fontWeight: '700' },
              container: { minHeight: '250px' },
            }}
          />
          <AboutFoodSection
            foodImage={foodImage}
            sectionTag="About Our Food"
            title="The Best Delicious Food Made From Us..."
            description="Its the perfect dining experience where every dish is crafted with fresh, high-quality dining experience Experience quick and efficient service that ensures your food is servead fresh Its the where every dining experience where every dish is crafted with fresh, high-quality ingredients fresh, high-quality"
            stats={[
              { number: '250+', label: 'Satisfied Clients' },
              { number: '153+', label: 'Total Food Categories' },
              { number: '25+', label: 'Award Win' },
            ]}
            foundationText="Foundation, Since 21st Oct, 2019"
          />
        </>
      )}
    </div>
  );
}
export default Aboutus;
